module.exports = __webpack_public_path__ + "static/media/ic_search_white.f6107547.svg";